import { render, staticRenderFns } from "./OpportunitiesList.vue?vue&type=template&id=d076cd94&scoped=true"
import script from "./OpportunitiesList.vue?vue&type=script&lang=js"
export * from "./OpportunitiesList.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesList.vue?vue&type=style&index=0&id=d076cd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d076cd94",
  null
  
)

export default component.exports